import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SalesforceReaderForm from '../forms/salesforce-reader-form';
import { salesforceReaderValidationSchema } from '../schema/salesforceReader.js';

export default function SalesforceReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Salesforce Reader Node Details',
        altText: 'Salesforce Reader Node',
        defaultLabel: 'Salesforce Reader Node',
      }}
    >
      <CommonNode
        FormComponent={SalesforceReaderForm}
        schemaResolver={salesforceReaderValidationSchema}
      />
    </NodeProvider>
  );
}
